<div class="d-flex my-1 align-items-center justify-content-center">
  <div class="line flex-fill"></div>
  <button
    type="button"
    class="btn d-flex border-0 text-info gap-2 align-items-center"
  >
    <ion-icon name="add-circle-outline" class="fs-5 text-info"></ion-icon>
    <ng-content></ng-content>
  </button>
  <div class="line flex-fill"></div>
</div>
